import React, { useState, useEffect, useCallback } from "react";
import {
  FaSearch,
  FaBell,
  FaList,
  FaEnvelope,
  FaUser,
  FaHome,
  FaUserPlus,
  FaUniversity,
  FaFileExcel,
  FaBook,
  FaClipboardList,
  FaBoxes,
  FaChartLine,
  FaComments,
  FaCertificate,
  FaVideo,
  FaFileAlt,
  FaMusic,
  FaGraduationCap,
  FaChalkboardTeacher,
} from "react-icons/fa";
import { RiMenu3Line } from "react-icons/ri";
import {
  MdKeyboardArrowRight,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdClose,
} from "react-icons/md";
import { Button, Layout, Tooltip, ConfigProvider, Modal } from "antd";
import { useSelector } from "react-redux";
import { Link, useNavigate, Outlet, useLocation } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import logo from "../asset/logowhite.png";
import { message } from "antd";
import { FaLayerGroup } from "react-icons/fa";
import { BsSun, BsMoon } from "react-icons/bs";

const { Header, Content, Sider } = Layout;

// Dark theme configuration for Ant Design
const darkTheme = {
  token: {
    colorBgBase: "#1f2937",
    colorTextBase: "#f9fafb",
    colorPrimary: "#3b82f6",
    colorBgContainer: "#374151",
    colorBorder: "#4b5563",
    colorBgLayout: "#111827",
  },
};

const lightTheme = {
  token: {
    colorBgBase: "#ffffff",
    colorTextBase: "#111827",
    colorPrimary: "#1890ff",
    colorBgContainer: "#ffffff",
    colorBorder: "#d1d5db",
    colorBgLayout: "#f9fafb",
  },
};

// Updated menu items based on admin functionality from flowcharts
const menuItems = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: <RxDashboard className="text-[#ffa404] dark:text-yellow-400" />,
    mobileIcon: <FaHome size={20} />,
    link: "/admin-panel/dashboard",
  },
  {
    key: "students",
    label: "Students",
    icon: <FaGraduationCap className="text-[#ffa404] dark:text-yellow-400" />,
    mobileIcon: <FaGraduationCap size={20} />,
    subItems: [
      {
        key: "student-create",
        label: "Create Student",
        link: "/admin-panel/Admin-student-create",
        mobileIcon: <FaUserPlus size={18} />,
        icon: <FaUserPlus className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
      {
        key: "student-list",
        label: "Student Reports",
        link: "/admin-panel/student-list",
        mobileIcon: <FaChartLine size={18} />,
        icon: <FaChartLine className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
    ],
  },
  {
    key: "instructors",
    label: "Instructors",
    icon: <FaChalkboardTeacher className="text-[#ffa404] dark:text-yellow-400" />,
    mobileIcon: <FaChalkboardTeacher size={20} />,
    subItems: [
      {
        key: "create-instructor",
        label: "Create Instructor",
        link: "/admin-panel/create-instructor",
        mobileIcon: <FaUserPlus size={18} />,
        icon: <FaUserPlus className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
      {
        key: "instructor-reports",
        label: "Instructor Reports",
        link: "/admin-panel/instructor-list",
        mobileIcon: <FaChartLine size={18} />,
        icon: <FaChartLine className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
    ],
  },
  {
    key: "college",
    label: "College",
    icon: <FaUniversity className="text-[#ffa404] dark:text-yellow-400" />,
    mobileIcon: <FaUniversity size={20} />,
    subItems: [
      {
        key: "college-management",
        label: "Create College",
        link: "/admin-panel/college-management",
        mobileIcon: <FaChalkboardTeacher size={18} />,
        icon: <FaChalkboardTeacher className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
      {
        key: "college-list",
        label: "College List",
        link: "/admin-panel/college-list",
        mobileIcon: <FaGraduationCap size={18} />,
        icon: <FaGraduationCap className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
      {
        key: "excel-upload",
        label: "Upload Excel",
        link: "/admin-panel/excel-upload",
        mobileIcon: <FaFileExcel size={18} />,
        icon: <FaFileExcel className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
    ],
  },
  {
    key: "category",
    label: "Category",
    icon: <FaLayerGroup className="text-[#ffa404] dark:text-yellow-400" />,
    mobileIcon: <FaLayerGroup size={20} />,
    subItems: [
      {
        key: "category-creation",
        label: "Category Management",
        link: "/admin-panel/category-creation",
        mobileIcon: <FaBoxes size={18} />,
        icon: <FaBoxes className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
    ],
  },
  {
    key: "courses",
    label: "Courses",
    icon: <FaBook className="text-[#ffa404] dark:text-yellow-400" />,
    mobileIcon: <FaBook size={20} />,
    subItems: [
      {
        key: "create-course",
        label: "Create Course",
        link: "/admin-panel/create-course",
        mobileIcon: <FaBook size={18} />,
        icon: <FaBook className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
      {
        key: "course-list",
        label: "Course List",
        link: "/admin-panel/course-list",
        mobileIcon: <FaList size={18} />,
        icon: <FaList className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
    ],
  },
  {
    key: "createBlog",
    label: "Blog",
    icon: <FaLayerGroup className="text-[#ffa404] dark:text-yellow-400" />,
    mobileIcon: <FaLayerGroup size={20} />,
    subItems: [
      {
        key: "createBlog",
        label: "Create Blog",
        link: "/admin-panel/create-blog",
        mobileIcon: <FaBoxes size={18} />,
        icon: <FaBoxes className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
      {
        key: "blogReport",
        label: "Blog Report",
        link: "/admin-panel/blog-report",
        mobileIcon: <FaBoxes size={18} />,
        icon: <FaBoxes className="text-[#ffa404] dark:text-yellow-400" size={14} />,
      },
    ],
  },
];

const AdminPanel = () => {
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();
  const location = useLocation();
  const [moreOpen, setMoreOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [openMenuItem, setOpenMenuItem] = useState(null);
  const [adminData, setAdminData] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Set active menu based on current URL when component loads or location changes
  useEffect(() => {
    const setActiveMenuFromURL = () => {
      const currentPath = location.pathname;
      
      for (const item of menuItems) {
        if (item.subItems) {
          for (const subItem of item.subItems) {
            if (subItem.link === currentPath) {
              setActiveMenu(subItem.key);
              setOpenMenuItem(item.key);
              return;
            }
          }
        }
        if (item.link === currentPath) {
          setActiveMenu(item.key);
          setOpenMenuItem(null);
          return;
        }
      }
      
      if (currentPath.includes('/admin-panel/dashboard') || currentPath === '/admin-panel') {
        setActiveMenu('dashboard');
      }
    };

    setActiveMenuFromURL();
  }, [location.pathname]);

  // Theme handling
  useEffect(() => {
    const savedTheme = sessionStorage.getItem("admin-theme");
    const shouldBeDark = savedTheme === "dark";
    setIsDarkMode(shouldBeDark);
    
    if (shouldBeDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, []);

  useEffect(() => {
    const handleThemeChange = () => {
      const savedTheme = sessionStorage.getItem("admin-theme");
      const shouldBeDark = savedTheme === "dark";
      setIsDarkMode(shouldBeDark);
      
      if (shouldBeDark) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    };

    window.addEventListener("themeChanged", handleThemeChange);
    const handleStorageChange = (e) => {
      if (e.key === "admin-theme") {
        handleThemeChange();
      }
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("adminThemeToggled", handleThemeChange);
    
    return () => {
      window.removeEventListener("themeChanged", handleThemeChange);
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("adminThemeToggled", handleThemeChange);
    };
  }, []);

  const toggleTheme = () => {
    const newIsDark = !isDarkMode;
    setIsDarkMode(newIsDark);
    
    if (newIsDark) {
      document.documentElement.classList.add("dark");
      sessionStorage.setItem("admin-theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      sessionStorage.setItem("admin-theme", "light");
    }
    
    window.dispatchEvent(new Event("themeChanged"));
    window.dispatchEvent(new Event("adminThemeToggled"));
    window.dispatchEvent(new StorageEvent('storage', {
      key: 'admin-theme',
      newValue: newIsDark ? 'dark' : 'light'
    }));
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  };

  // Check authentication status
  useEffect(() => {
    const checkAuth = () => {
      const storedAdminData = sessionStorage.getItem("adminData");
      const storedAdminUser = sessionStorage.getItem("adminUser");

      if (!storedAdminData || !storedAdminUser) {
        navigate("/admin-panel/admin-login");
      } else {
        try {
          setAdminData(JSON.parse(storedAdminData));
        } catch (err) {
          console.error("Failed to parse adminData:", err);
          handleLogout();
        }
      }
    };

    checkAuth();
  }, [navigate, location.pathname]);

  // Mobile detection - only <768px shows bottom nav
  const checkIsMobile = useCallback(() => window.innerWidth < 768, []);

useEffect(() => {
  const handleResize = () => {
    const width = window.innerWidth;
    const mobile = width < 768;
    const tablet = width >= 768 && width < 1024;
    
    setIsMobile(mobile);
    
    // Set sidebar state based on screen size
    if (mobile) {
      setIsSidebarCollapsed(true); // Mobile = collapsed
    } else if (tablet) {
      setIsSidebarCollapsed(true); // Tablet = collapsed by default
    } else {
      setIsSidebarCollapsed(false); // Desktop = expanded
    }
  };

  handleResize();
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  // Mobile primary navigation
  const mobilePrimary = [
    {
      key: "dashboard",
      label: "Home",
      link: "/admin-panel/dashboard",
      icon: <FaHome size={20} />,
    },
    {
      key: "students",
      label: "Students",
      link: "/admin-panel/student-list",
      icon: <FaGraduationCap size={20} />,
    },
    {
      key: "instructors",
      label: "Instructors",
      link: "/admin-panel/instructor-list",
      icon: <FaChalkboardTeacher size={20} />,
    },
  ];

  const allMobileItems = (() => {
    const items = [];
    menuItems.forEach((item) => {
      if (item.link) {
        items.push({
          ...item,
          mobileIcon: item.mobileIcon || item.icon,
        });
      }
      if (item.subItems) {
        item.subItems.forEach((subItem) => {
          items.push({
            ...subItem,
            mobileIcon: subItem.mobileIcon || item.icon,
          });
        });
      }
    });
    return items;
  })();

  const mobileExtra = allMobileItems
    .filter(
      (item) => !mobilePrimary.some((primary) => primary.key === item.key || primary.link === item.link)
    );

  const handleLogout = () => {
    Modal.confirm({
      title: "Confirm Logout",
      content: "Are you sure you want to log out?",
      okText: "Yes",
      cancelText: "Cancel",
      okButtonProps: { danger: true },
      className: isDarkMode ? "dark-modal" : "",
      onOk: () => {
        sessionStorage.removeItem("adminData");
        sessionStorage.removeItem("adminUser");
        message.success("Logged out successfully");
        navigate("/admin-panel/admin-login");
      },
    });
  };

  const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev);

  const handleMenuClick = (key, hasSubItems, link) => {
    if (hasSubItems) {
      setOpenMenuItem((prev) => (prev === key ? null : key));
      setActiveMenu(key);
    } else {
      navigate(link);
      setActiveMenu(key);
      setMoreOpen(false);
    }

    if (isSidebarCollapsed && hasSubItems) {
      setIsSidebarCollapsed(false);
    }
  };

  const isMenuItemActive = (item) => {
    if (item.link) {
      return activeMenu === item.key && location.pathname === item.link;
    }
    if (item.subItems) {
      return (
        activeMenu === item.key ||
        item.subItems.some(sub => activeMenu === sub.key)
      );
    }
    return false;
  };

  const shouldExpandSubmenu = (item) => {
    return (
      openMenuItem === item.key ||
      item.subItems?.some(sub => activeMenu === sub.key)
    );
  };

  const renderDesktopMenuItems = () => (
    <div
      className={`transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-b from-[#001529] to-[#003366]'
      }`}
      style={{
        color: "#fff",
        height: "100%",
      }}
    >
      <div
        className={`transition-colors duration-300 ${
          isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-[#001529] border-white/10'
        }`}
        style={{
          padding: "1rem",
          textAlign: "center",
          borderBottom: isDarkMode ? "1px solid #374151" : "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <Link to="/admin-panel">
          <img
            src={logo}
            alt="logo"
            style={{
              width: isSidebarCollapsed ? 40 : 128,
              transition: "width 0.2s",
              filter: "brightness(0) invert(1)",
            }}
          />
        </Link>
      </div>

      {menuItems.map((item) => {
        const isActive = isMenuItemActive(item);
        const isExpanded = shouldExpandSubmenu(item);
        const isHovered = hoveredItem === item.key;

        return (
          <div
            key={item.key}
            style={{ borderBottom: isDarkMode ? "1px solid #374151" : "1px solid rgba(255,255,255,0.1)" }}
          >
            <div
              onClick={() =>
                handleMenuClick(item.key, !!item.subItems, item.link)
              }
              onMouseEnter={() => setHoveredItem(item.key)}
              onMouseLeave={() => setHoveredItem(null)}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "1rem",
                cursor: "pointer",
                backgroundColor: isActive
                  ? (isDarkMode ? "#1e40af" : "#1f4774")
                  : isHovered
                  ? (isDarkMode ? "#1e3a8a" : "#1e3a8a")
                  : "transparent",
                justifyContent: isSidebarCollapsed ? "center" : "space-between",
                transition: "background-color 0.3s ease",
                borderLeft: isActive ? "3px solid #ffa404" : "3px solid transparent",
              }}
            >
              {isSidebarCollapsed ? (
                <Tooltip title={item.label} placement="right">
                  <span style={{ color: isActive ? "#ffa404" : "#fff" }}>
                    {item.icon}
                  </span>
                </Tooltip>
              ) : (
                <>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        marginRight: "0.75rem",
                        color: isActive ? "#ffa404" : "#fff",
                      }}
                    >
                      {item.icon}
                    </span>
                    <span
                      style={{
                        color: isActive ? "#fff" : "#fff",
                        fontWeight: isActive ? "bold" : "normal",
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                  {item.subItems &&
                    (isExpanded ? (
                      <MdKeyboardArrowDown style={{ color: "#fff" }} />
                    ) : (
                      <MdKeyboardArrowRight style={{ color: "#fff" }} />
                    ))}
                </>
              )}
            </div>

            {!isSidebarCollapsed && item.subItems && isExpanded && (
              <div style={{ background: isDarkMode ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.2)" }}>
                {item.subItems.map((subItem) => {
                  const isSubItemActive =
                    activeMenu === subItem.key &&
                    location.pathname === subItem.link;
                  return (
                    <Link
                      to={subItem.link}
                      key={subItem.key}
                      onClick={() => setActiveMenu(subItem.key)}
                    >
                      <div
                        onMouseEnter={() => setHoveredItem(subItem.key)}
                        onMouseLeave={() => setHoveredItem(null)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "0.75rem 1.5rem",
                          cursor: "pointer",
                          backgroundColor: isSubItemActive
                            ? (isDarkMode ? "#1e40af" : "#1f4774")
                            : hoveredItem === subItem.key
                            ? (isDarkMode ? "#1e3a8a" : "#1e3a8a")
                            : "transparent",
                          color: "#fff",
                          transition: "background-color 0.3s ease",
                          borderLeft: isSubItemActive ? "3px solid #ffa404" : "3px solid transparent",
                        }}
                      >
                        <span style={{ marginRight: "0.75rem" }}>
                          {subItem.icon || (
                            <FaFileAlt className="text-[#ffa404]" size={14} />
                          )}
                        </span>
                        <span>{subItem.label}</span>
                      </div>
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );


const renderMobileBottomNav = () => {
  if (!isMobile) return null;

  return (
    <>
      <div
        className={`transition-colors duration-300 ${
          isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
        }`}
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          zIndex: 1000,
          borderTop: isDarkMode ? "1px solid #374151" : "1px solid #eee",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            height: "60px",
            padding: "0 10px",
          }}
        >
          {mobilePrimary.map((item) => {
            const isActive = activeMenu === item.key || location.pathname === item.link;

            return (
              <div
                key={item.key}
                onClick={() => {
                  setActiveMenu(item.key);
                  navigate(item.link);
                  setMoreOpen(false);
                }}
                style={{
                  cursor: "pointer",
                  flex: 1,
                  textAlign: "center",
                  padding: "5px 0",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: isActive 
                    ? (isDarkMode ? "#60a5fa" : "#1f4774") 
                    : (isDarkMode ? "#9ca3af" : "#666"),
                  backgroundColor: "transparent",
                  transition: "all 0.2s",
                }}
              >
                <div style={{ fontSize: "22px" }}>{item.icon}</div>
                <div style={{ 
                  fontSize: "11px", 
                  marginTop: "3px",
                  fontWeight: isActive ? "600" : "normal"
                }}>
                  {item.label}
                </div>
              </div>
            );
          })}

          <div
            onClick={() => setMoreOpen(true)}
            style={{
              cursor: "pointer",
              flex: 1,
              textAlign: "center",
              padding: "5px 0",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              color: moreOpen || mobileExtra.some(i => activeMenu === i.key) 
                ? (isDarkMode ? "#60a5fa" : "#1f4774") 
                : (isDarkMode ? "#9ca3af" : "#666"),
            }}
          >
            <div style={{ fontSize: "22px" }}>
              <MdKeyboardArrowUp />
            </div>
            <div style={{ fontSize: "11px", marginTop: "3px" }}>More</div>
          </div>
        </div>
      </div>

      {moreOpen && (
        <div
          className={`transition-colors duration-300 ${
            isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
          }`}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1100,
            overflowY: "auto",
            padding: "20px",
            paddingBottom: "80px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
              paddingBottom: "10px",
              borderBottom: isDarkMode ? "1px solid #374151" : "1px solid #eee",
            }}
          >
            <h2 style={{ margin: 0, color: isDarkMode ? "#f9fafb" : "#333" }}>Menu</h2>
            <button
              onClick={() => setMoreOpen(false)}
              style={{
                background: "none",
                border: "none",
                fontSize: "24px",
                color: isDarkMode ? "#9ca3af" : "#666",
                cursor: "pointer",
              }}
            >
              <MdClose />
            </button>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "15px",
            }}
          >
            {mobileExtra.map((item) => (
              <div
                key={item.key}
                onClick={() => {
                  setActiveMenu(item.key);
                  navigate(item.link);
                  setMoreOpen(false);
                }}
                className={`transition-all duration-200 ${
                  isDarkMode 
                    ? 'hover:bg-blue-700' 
                    : 'hover:bg-blue-700'
                }`}
                style={{
                  padding: "15px",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  backgroundColor: activeMenu === item.key 
                    ? (isDarkMode ? "#2563eb" : "#1f4774") 
                    : "transparent",

                }}
              >
                <span
                  style={{
                    fontSize: isMobile ? "28px" : "32px",
                    marginBottom: "10px",
                    color: activeMenu === item.key 
                      ? "#ffffff" 
                      : (isDarkMode ? "#9ca3af" : "#666"),
                  }}
                >
                  {item.mobileIcon}
                </span>
                <span
                  style={{
                    fontSize: isMobile ? "13px" : "15px",
                    textAlign: "center",
                    color: activeMenu === item.key 
                      ? "#ffffff" 
                      : (isDarkMode ? "#f9fafb" : "#333"),
                    lineHeight: "1.3",
                    fontWeight: activeMenu === item.key ? "600" : "normal",
                  }}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

  return (
    <ConfigProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <Layout style={{ minHeight: "100vh" }} className={isDarkMode ? 'bg-gray-900' : 'bg-white'}>
        {!isMobile && (
          <Sider
            trigger={null}
            collapsible
            collapsed={isSidebarCollapsed}
            breakpoint="md"
            collapsedWidth={80}
            width={250}
            style={{
              position: "fixed",
              left: 0,
              top: 0,
              bottom: 0,
              zIndex: 50,
            }}
          >
            {renderDesktopMenuItems()}
          </Sider>
        )}

        <Layout
          className={`transition-colors duration-300 ${
            isDarkMode ? 'bg-gray-900' : 'bg-white'
          }`}
          style={{
            marginLeft: !isMobile ? (isSidebarCollapsed ? 80 : 250) : 0,
            transition: "margin-left 0.2s",
            minHeight: "100vh",
            paddingBottom: isMobile ? "80px" : "0",
          }}
        >
<Header
  className={`transition-colors duration-300 ${
    isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-r from-[#001529] to-[#003366]'
  }`}
  style={{
    color: "#fff",
    padding: "0.75rem 1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: !isMobile ? (isSidebarCollapsed ? 80 : 250) : 0,
    right: 0,
    zIndex: 10,
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  }}
>
  <div style={{ display: "flex", alignItems: "center" }}>
    {!isMobile && (
      <Button
        type="text"
        icon={<RiMenu3Line style={{ color: "#fff" }} />}
        onClick={toggleSidebar}
        style={{ marginRight: "1rem" }}
      />
    )}
    {/* Logo for mobile */}
{isMobile && (
  <img
    src={logo}
    alt="logo"
    style={{
     width: "85px",  // Increased from 52px
          height: "85px",
      marginRight: "0.75rem",
      filter: "brightness(0) invert(1)",
      objectFit: "contain",
    }}
  />
)}
    <div
      className="hidden md:block"
      style={{
        fontWeight: "bold",
        fontSize: "1.125rem",
        cursor: "pointer",
        color: "#fff",
      }}
      onClick={() => navigate("/admin-panel/dashboard")}
    >
      Admin Dashboard
    </div>
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <Button
      type="text"
      onClick={toggleTheme}
      style={{
        fontSize: "18px",
        color: "white",
        background: "transparent",
        border: "none",
        padding: 0,
        width: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isDarkMode ? (
        <BsSun style={{ color: "#fbbf24" }} />
      ) : (
        <BsMoon style={{ color: "#ffffff" }} />
      )}
    </Button>

    <Tooltip title="Notifications">
      <FaBell style={{ color: "#fff", cursor: "pointer" }} />
    </Tooltip>
    <Tooltip title="Messages">
      <FaEnvelope style={{ color: "#fff", cursor: "pointer" }} />
    </Tooltip>
    <Tooltip title={user?.user_name || "User"}>
      <FaUser style={{ color: "#fff", cursor: "pointer" }} />
    </Tooltip>

    <Button
      type="primary"
      onClick={handleLogout}
      style={{ 
        backgroundColor: "#d93025", 
        borderColor: "#d93025",
        border: "none",
        boxShadow: "none"
      }}
    >
      Logout
    </Button>
  </div>
</Header>
          <Content
            className={`transition-colors duration-300 ${
              isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
            }`}
            style={{
              margin: isMobile ? "64px 0 0 0" : "88px 16px 24px 16px",
              padding: isMobile ? "16px" : "24px",
              minHeight: "calc(100vh - 64px)",
            }}
          >
            <Outlet />
          </Content>

          {renderMobileBottomNav()}
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default AdminPanel;